import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAdmin } from "../../../contexts/AdminContext";

const FEATURED_BASE = {
  name: "Thomas Belanger",
  city: "Berlin, DE",
  prize: "Moderne Villa 500 m²",
  draw: 47,
  date: "März 2024",
  avatar: "https://readdy.ai/api/search-image?query=confident%20happy%20German%20man%20in%20his%2040s%2C%20casual%20elegant%20style%2C%20warm%20smile%2C%20outdoor%20urban%20background%20Berlin%2C%20natural%20lighting%2C%20portrait%20photography%2C%20realistic%20professional%20photo%2C%20shallow%20depth%20of%20field%2C%20modern%20look&width=400&height=500&seq=winner-thomas-1&orientation=portrait",
  house: "https://readdy.ai/api/search-image?query=stunning%20modern%20luxury%20villa%20with%20swimming%20pool%2C%20white%20stone%20architecture%2C%20beautiful%20garden%20with%20olive%20trees%2C%20blue%20sky%2C%20German%20style%20estate%2C%20real%20estate%20photography%2C%20golden%20hour%20warm%20light%2C%20dream%20home%20exterior&width=700&height=480&seq=winner-house-1&orientation=landscape",
  quote: "Ich konnte es kaum glauben, als ich den Anruf erhielt. Meine Frau weinte vor Freude. Wir haben schon immer von einem echten Haus für unsere Familie geträumt. Heute gehört diese Villa uns. Es schien unmöglich, und doch...",
  tickets: 35,
  stars: 5,
  verified: true,
};

const DUMMY_TESTIMONIALS = [
  {
    id: 1,
    name: "Claire Morel",
    city: "Hamburg, DE",
    prize: "Tesla Model X",
    prizeValue: "95.000 €",
    draw: 50,
    date: "Jan 2025",
    avatar: "https://readdy.ai/api/search-image?query=happy%20German%20woman%20in%20her%2030s%2C%20natural%20beauty%2C%20warm%20smile%2C%20professional%20portrait%2C%20soft%20bokeh%20background%2C%20clean%20look%2C%20lifestyle%20photography%2C%20natural%20light%2C%20authentic%20expression&width=200&height=200&seq=winner-claire-1&orientation=squarish",
    quote: "Ich hatte das Klassik-Paket nur gekauft, um mein Glück zu versuchen. Zwei Wochen später erhalte ich eine E-Mail… ich habe den Tesla gewonnen! Ich fahre meinen Traum seit Januar.",
    tickets: 17,
    stars: 5,
    verified: true,
    tagColor: "bg-sky-100 text-sky-700",
  },
  {
    id: 2,
    name: "Marc Fontaine",
    city: "München, DE",
    prize: "50.000 € Cash",
    prizeValue: "50.000 €",
    draw: 49,
    date: "Dez 2024",
    avatar: "https://readdy.ai/api/search-image?query=smiling%20German%20man%20in%20his%2050s%2C%20relaxed%20confident%20posture%2C%20casual%20shirt%2C%20outdoor%20cafe%20background%2C%20warm%20natural%20light%2C%20portrait%20photo%2C%20friendly%20expression%2C%20authentic%20lifestyle&width=200&height=200&seq=winner-marc-1&orientation=squarish",
    quote: "50.000 € auf einen Schlag, das ändert das Leben! Ich habe meinen Kredit abbezahlt und meine ganze Familie auf eine Reise mitgenommen. Danke German Traumhaus Lotterie, ihr habt mir die Gelassenheit zurückgegeben.",
    tickets: 43,
    stars: 5,
    verified: true,
    tagColor: "bg-amber-100 text-amber-700",
  },
  {
    id: 3,
    name: "Sophie Laurent",
    city: "Frankfurt, DE",
    prize: "Weltreise",
    prizeValue: "45.000 €",
    draw: 48,
    date: "Nov 2024",
    avatar: "https://readdy.ai/api/search-image?query=joyful%20German%20woman%20in%20her%20late%2020s%2C%20bright%20smile%2C%20casual%20chic%20look%2C%20soft%20background%2C%20natural%20portrait%20lighting%2C%20authentic%20happy%20expression%2C%20warm%20skin%20tones%2C%20lifestyle%20photo&width=200&height=200&seq=winner-sophie-1&orientation=squarish",
    quote: "30 Tage um die Welt mit meinem Partner! Bali, Japan, Mexiko, Malediven… Ein wahr gewordener Traum mit einem einfachen 65€ Ticket. Ich empfehle es jedem!",
    tickets: 17,
    stars: 5,
    verified: true,
    tagColor: "bg-emerald-100 text-emerald-700",
  },
  {
    id: 4,
    name: "Julien Marceau",
    city: "Stuttgart, DE",
    prize: "Trostpreis",
    prizeValue: "1.000 €",
    draw: 51,
    date: "Feb 2025",
    avatar: "https://readdy.ai/api/search-image?query=cheerful%20young%20German%20man%20in%20his%2020s%2C%20casual%20modern%20style%2C%20genuine%20smile%2C%20urban%20background%2C%20natural%20light%20portrait%2C%20candid%20expression%2C%20authentic%20everyday%20look&width=200&height=200&seq=winner-julien-1&orientation=squarish",
    quote: "Mein allererster Gewinn! 1.000€, die ich für ein Wochenende in Rom mit meiner Freundin genutzt habe. Schon bereit für die nächste Ziehung, diesmal ziele ich auf die Villa ab!",
    tickets: 5,
    stars: 4,
    verified: true,
    tagColor: "bg-rose-100 text-rose-700",
  },
  {
    id: 5,
    name: "Isabelle Renard",
    city: "Düsseldorf, DE",
    prize: "Trostpreis",
    prizeValue: "1.000 €",
    draw: 51,
    date: "Feb 2025",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20German%20woman%20in%20her%2040s%2C%20sophisticated%20look%2C%20warm%20smile%2C%20soft%20indoor%20lighting%2C%20professional%20headshot%20style%2C%20natural%20beauty%2C%20calm%20confident%20expression%2C%20warm%20tones&width=200&height=200&seq=winner-isabelle-1&orientation=squarish",
    quote: "Der Prozess ist so einfach und beruhigend. Ich habe meine Tickets in 1 Minute per E-Mail erhalten. Die Ziehung ist transparent, alles ist zertifiziert. Eine wirklich ernsthafte Erfahrung.",
    tickets: 25,
    stars: 5,
    verified: true,
    tagColor: "bg-rose-100 text-rose-700",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={`w-3.5 h-3.5 flex items-center justify-center ${i < count ? "text-primary-light" : "text-slate-200"}`}>
          <i className="ri-star-fill text-xs"></i>
        </span>
      ))}
    </div>
  );
}

function VerifiedBadge() {
  return (
    <span className="inline-flex items-center gap-1 bg-emerald-50 text-secondary-dark text-xs font-semibold px-2 py-0.5 rounded-full border border-emerald-100">
      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-verified-badge-line text-xs"></i></span>
      Verifiziert
    </span>
  );
}

export default function Testimonials() {
  const { settings } = useAdmin();
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [scrollPos, setScrollPos] = useState(0);
  const carouselRef = useRef<HTMLDivElement>(null);

  const FEATURED = {
    ...FEATURED_BASE,
    prizeValue: settings.lotteryValue,
  };

  const TESTIMONIALS = settings.testimonials.length > 0 
    ? settings.testimonials.map((t, idx) => ({
        id: idx + 100,
        name: t.name,
        city: "Teilnehmer",
        prize: "Gewinn erhalten",
        prizeValue: "Bewertung läuft",
        draw: 51,
        date: "Vor kurzem",
        avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(t.name)}&background=random`,
        quote: t.content,
        stars: t.rating,
        verified: true,
        tagColor: "bg-slate-100 text-slate-700",
      }))
    : DUMMY_TESTIMONIALS;

  // Intersection observer for entrance animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Auto-scroll carousel
  useEffect(() => {
    const iv = setInterval(() => {
      setScrollPos((prev) => {
        const next = prev + 1;
        return next >= TESTIMONIALS.length ? 0 : next;
      });
    }, 4000);
    return () => clearInterval(iv);
  }, [TESTIMONIALS.length]);

  useEffect(() => {
    if (!carouselRef.current) return;
    const container = carouselRef.current;
    const card = container.children[scrollPos] as HTMLElement;
    
    if (card) {
      const targetLeft = card.offsetLeft - (container.offsetWidth / 2) + (card.offsetWidth / 2);
      container.scrollTo({
        left: targetLeft,
        behavior: "smooth"
      });
    }
  }, [scrollPos]);

  return (
    <section ref={sectionRef} className="py-24 overflow-hidden" style={{ background: "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)" }}>
      <div className="max-w-7xl mx-auto px-6">

        {/* ===== Section Header ===== */}
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="uppercase text-secondary text-xs font-bold tracking-widest">
            Sie haben gewonnen – warum nicht auch Sie?
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Veränderte Leben,<br />
            <em className="text-slate-500 font-normal">Träume werden wahr</em>
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto leading-relaxed">
            Seit 2022 haben über 98 Gewinner ihre zertifizierten Preise erhalten. Hier sind ihre Geschichten.
          </p>

          {/* Trust aggregate */}
          <div className="inline-flex items-center gap-3 mt-6 bg-white border border-slate-200 rounded-full px-5 py-2.5 shadow-sm">
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <span key={i} className="w-4 h-4 flex items-center justify-center text-primary-light">
                  <i className="ri-star-fill text-sm"></i>
                </span>
              ))}
            </div>
            <span className="text-slate-700 font-bold text-sm">4,9/5</span>
            <div className="w-px h-4 bg-slate-200"></div>
            <span className="text-slate-500 text-sm">Basierend auf 312 verifizierten Bewertungen</span>
          </div>
        </div>

        {/* ===== FEATURED WINNER (big card) ===== */}
        <div className={`mb-10 transition-all duration-700 delay-100 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative bg-white rounded-3xl overflow-hidden border border-slate-100 group">
            <div className="grid grid-cols-1 lg:grid-cols-5">

              {/* Left: Portrait + house collage */}
              <div className="lg:col-span-2 relative h-72 lg:h-auto overflow-hidden">
                {/* House background */}
                <div className="absolute inset-0">
                  <img
                    src={FEATURED.house}
                    alt="Gewonnene Villa"
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent lg:bg-gradient-to-r lg:from-black/40 lg:via-black/20 lg:to-transparent" />
                </div>

                {/* Portrait bubble */}
                <div className="absolute bottom-5 left-5 flex items-end gap-3">
                  <div className="w-16 h-16 rounded-2xl overflow-hidden border-2 border-white shadow-xl flex-shrink-0">
                    <img
                      src={FEATURED.avatar}
                      alt={FEATURED.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-white font-bold text-base drop-shadow-md">{FEATURED.name}</p>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <span className="text-white/70 text-xs">{FEATURED.city}</span>
                      <span className="text-white/40 text-xs">•</span>
                      <span className="text-white/70 text-xs">{FEATURED.date}</span>
                    </div>
                  </div>
                </div>

                {/* Prize badge */}
                <div className="absolute top-4 left-4">
                  <div className="bg-primary text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg">
                    🏆 Hauptpreis — Ziehung #{FEATURED.draw}
                  </div>
                </div>
              </div>

              {/* Right: Quote + details */}
              <div className="lg:col-span-3 p-8 md:p-10 flex flex-col justify-between">
                <div>
                  {/* Stars + verified */}
                  <div className="flex items-center gap-3 mb-5">
                    <StarRating count={FEATURED.stars} />
                    <VerifiedBadge />
                    <span className="text-slate-400 text-xs">Zertifizierter Gewinner</span>
                  </div>

                  {/* Opening quote mark */}
                  <div className="w-10 h-10 flex items-center justify-center mb-3">
                    <i className="ri-double-quotes-l text-4xl text-orange-200"></i>
                  </div>

                  <blockquote className="font-playfair text-xl md:text-2xl text-slate-800 leading-relaxed italic mb-6">
                    "{FEATURED.quote}"
                  </blockquote>
                </div>

                {/* Bottom row */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 pt-5 border-t border-slate-100">
                  {/* Prize details */}
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-orange-50 border border-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-home-heart-line text-primary text-xl"></i>
                    </div>
                    <div>
                      <p className="font-bold text-slate-900">{FEATURED.prize}</p>
                      <p className="text-slate-500 text-sm">Wert : <span className="text-primary font-bold font-playfair">{FEATURED.prizeValue}</span></p>
                    </div>
                  </div>

                  {/* Ticket info */}
                  <div className="flex items-center gap-2 bg-slate-50 rounded-xl px-4 py-3 border border-slate-100">
                    <span className="w-5 h-5 flex items-center justify-center text-slate-400">
                      <i className="ri-ticket-2-line text-sm"></i>
                    </span>
                    <div>
                      <p className="text-slate-900 font-semibold text-sm">{FEATURED.tickets} Lose</p>
                      <p className="text-slate-400 text-xs">eingesetzt zum Gewinnen</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== GRID TESTIMONIALS (desktop) ===== */}
        <div className={`hidden lg:grid grid-cols-3 gap-5 mb-8 transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {TESTIMONIALS.slice(0, 3).map((t) => (
            <div
              key={t.id}
              onMouseEnter={() => setActiveCard(t.id)}
              onMouseLeave={() => setActiveCard(null)}
              className={`bg-white rounded-2xl border p-6 flex flex-col transition-all duration-300 cursor-pointer ${activeCard === t.id ? "border-slate-300 shadow-xl -translate-y-1" : "border-slate-100 shadow-sm hover:shadow-lg"}`}
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 border border-slate-100">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                    <p className="text-slate-400 text-xs">{"city" in t ? (t as any).city : "Teilnehmer"} · {"date" in t ? (t as any).date : "Vor kurzem"}</p>
                  </div>
                </div>
                <VerifiedBadge />
              </div>

              {/* Stars */}
              <StarRating count={t.stars} />

              {/* Quote */}
              <blockquote className="text-slate-600 text-sm leading-relaxed mt-3 flex-1 italic">
                "{t.quote}"
              </blockquote>

              {/* Prize tag */}
              <div className="mt-4 pt-4 border-t border-slate-50 flex items-center justify-between">
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${"tagColor" in t ? (t as any).tagColor : "bg-slate-100 text-slate-700"}`}>
                  {t.prize}
                </span>
                <span className="font-bold text-slate-900 text-sm font-playfair">{t.prizeValue}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Extra testimonials - desktop */}
        {TESTIMONIALS.length > 3 && (
          <div className={`hidden lg:grid grid-cols-2 gap-5 mb-10 transition-all duration-700 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {TESTIMONIALS.slice(3, 5).map((t) => (
              <div
                key={t.id}
                onMouseEnter={() => setActiveCard(t.id)}
                onMouseLeave={() => setActiveCard(null)}
                className={`bg-white rounded-2xl border p-6 flex gap-4 transition-all duration-300 cursor-pointer ${activeCard === t.id ? "border-slate-300 shadow-xl -translate-y-1" : "border-slate-100 shadow-sm hover:shadow-lg"}`}
              >
                <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 border border-slate-100">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <div className="flex items-center gap-2">
                      <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                      <VerifiedBadge />
                    </div>
                    <StarRating count={t.stars} />
                  </div>
                  <p className="text-slate-400 text-xs mb-2">{"city" in t ? (t as any).city : "Teilnehmer"} · {"date" in t ? (t as any).date : "Vor kurzem"}</p>
                  <blockquote className="text-slate-600 text-sm leading-relaxed italic">"{t.quote}"</blockquote>
                  <div className="mt-3 flex items-center gap-2">
                    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${"tagColor" in t ? (t as any).tagColor : "bg-slate-100 text-slate-700"}`}>{t.prize}</span>
                    <span className="text-slate-900 font-bold text-sm">{t.prizeValue}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ===== MOBILE CAROUSEL ===== */}
        <div className="lg:hidden">
          <div
            ref={carouselRef}
            className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {TESTIMONIALS.map((t) => (
              <div
                key={t.id}
                className="flex-none w-[85vw] bg-white rounded-2xl border border-slate-100 p-5 snap-start"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-xl overflow-hidden border border-slate-100">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                    <p className="text-slate-400 text-xs">{"city" in t ? (t as any).city : "Teilnehmer"}</p>
                  </div>
                  <div className="ml-auto"><StarRating count={t.stars} /></div>
                </div>
                <blockquote className="text-slate-600 text-sm leading-relaxed italic mb-3">"{t.quote}"</blockquote>
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${"tagColor" in t ? (t as any).tagColor : "bg-slate-100 text-slate-700"}`}>{t.prize} — {t.prizeValue}</span>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-3">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setScrollPos(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${scrollPos === i ? "w-6 h-2 bg-secondary" : "w-2 h-2 bg-slate-300"}`}
              />
            ))}
          </div>
        </div>

        {/* ===== CTA Banner ===== */}
        <div className={`mt-10 transition-all duration-700 delay-400 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative rounded-3xl overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20happy%20diverse%20group%20of%20people%20celebrating%20with%20champagne%20and%20confetti%2C%20luxury%20event%20party%20atmosphere%2C%20warm%20golden%20light%2C%20elegant%20venue%2C%20joyful%20expressions%2C%20professional%20photography%2C%20celebration%20success%20lifestyle&width=1200&height=300&seq=testimonials-cta-bg&orientation=landscape"
                alt="Gewinner feiern"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/50" />
            </div>
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 p-8 md:p-10">
              <div>
                <p className="text-white/60 text-sm uppercase tracking-widest mb-1">Die nächste Gewinnergeschichte</p>
                <h3 className="font-playfair text-2xl md:text-3xl font-bold text-white">
                  Könnte es Ihre sein?
                </h3>
                <p className="text-white/70 text-sm mt-2">
                  Ziehung {settings.drawId} · {settings.nextDrawDate} · Villa im Wert von <span className="text-primary-light font-bold">{settings.lotteryValue}</span>
                </p>
              </div>
              <Link
                to="/forfaits"
                className="flex-shrink-0 inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-bold px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap shadow-xl hover:-translate-y-0.5 text-base"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-ticket-2-line text-lg"></i></span>
                Jetzt teilnehmen
              </Link>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
